import { Box, Typography } from "@mui/material";

// Dark "hero" variant of StatCard — same slot as the admin dashboard's
// dark hero tile (Total Revenue/Total Orders in pages/admin/Dashboard.js),
// used for the first summary card so the patient/therapist dashboards open
// with the same accent as admin.
function StatCardDark({ icon, value, label }) {
  return (
    <Box
      sx={{
        flex: "1.3 1 220px",
        minWidth: 220,
        borderRadius: "24px",
        background: "#163666",
        color: "#fff",
        p: "22px 24px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: "9px",
          background: "rgba(255,255,255,0.1)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {icon}
      </Box>
      <Box>
        <Typography sx={{ fontSize: 30, fontWeight: 800, letterSpacing: "-0.02em", lineHeight: 1.1 }}>
          {value}
        </Typography>
        <Typography sx={{ fontSize: 13, color: "rgba(255,255,255,0.6)", mt: "2px" }}>{label}</Typography>
      </Box>
    </Box>
  );
}

export default StatCardDark;
